import { isCapabilityEnabled } from 'owa-capabilities';
import { bizchatDrawerCapability } from 'owa-capabilities-definitions/lib/bizchatDrawerCapability';
import { logBizChatSidePaneEntrypoint } from 'owa-bizchat-shared/lib/utils/logBizChatSidePaneEntrypoint';
import { prefetchBizChatAuthTokens } from 'owa-bizchat-shared/lib/utils/prefetchBizChatAuthTokens';
import { prefetchSSRTokenForAutoOpen } from 'owa-bizchat-shared/lib/utils/prefetchSSRTokenForAutoOpen';
import {
    markDisableAutoFocusForCurrentOpen,
    openCopilotChatDrawer,
} from 'owa-copilot-chat-drawer-store';
import openFlexPaneHelper from 'owa-app-pane-group-utils/lib/helpers/openFlexPaneHelper';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

const CHAT_COPILOT_FLEXPANE_ID = 'ChatCopilot';

/**
 * Handles auto-opening of Copilot Chat pane with telemetry and prefetch
 */
export function handleCopilotChatAutoOpen(): void {
    const mailboxInfo = getModuleContextMailboxInfo();

    logBizChatSidePaneEntrypoint(
        /* source */ 'StickyOpen',
        /* mailboxInfo */ mailboxInfo,
        /* targetWindow */ window
    );
    void prefetchBizChatAuthTokens('BizChatSidePaneStickyOpen');
    void prefetchSSRTokenForAutoOpen(mailboxInfo);

    if (isCapabilityEnabled(bizchatDrawerCapability)) {
        markDisableAutoFocusForCurrentOpen();
        openCopilotChatDrawer(window, mailboxInfo);
    } else {
        openFlexPaneHelper(CHAT_COPILOT_FLEXPANE_ID, 'chatCopilot');
    }
}
